import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseEntityResolver } from '@ishop/admin-ui/core';
import { Category } from '@ishop/admin-ui/core';
import { getDefaultUiLanguage } from '@ishop/admin-ui/core';
import { DataService } from '@ishop/admin-ui/core';

/**
 * Resolves the id from the path into a Customer entity.
 */
@Injectable({
    providedIn: 'root',
})
export class VendorCategoryResolver extends BaseEntityResolver<Category.Fragment> {
    constructor(router: Router, dataService: DataService) {
        super(
            router,
            {
                __typename: 'Category',
                languageCode: getDefaultUiLanguage(),
                translations: [],
                id: '',
                createdAt: '',
                updatedAt: '', 
                name: '',
                slug: '',  
                featuredAsset: null,  
            },
            id => dataService.settings.getCategory(id).mapStream(data => data.vendorCategory),
        );
    }
}
